export const LEGACY_TECHNICAL_REPORT_MESSAGE =
  "This imported TC case has a technical report. Open its original Technical Summary; pathology report revisions are not available.";

export function isLegacyTechnicalReportError(error: unknown): boolean {
  const response = (
    error as { response?: { status?: number; data?: { code?: unknown } } }
  )?.response;
  return (
    response?.status === 409 &&
    response.data?.code === "legacy_technical_summary_only"
  );
}
